<template>
    <div
        class="widget shows-widget"
    >
        <header class="widget-header">
            <p class="title">
                Your Shows
            </p>
            <router-link
                :to="'/shows/'"
                class="arrow-link"
            >
                See all shows <i class="far fa-long-arrow-right" />
            </router-link>
        </header>
        <transition-group
            name="fade"
            mode="out-in"
        >
            <base-loader
                v-if="null === shows"
                key="loader"
            />
            <p
                v-else-if="0 === recentShows.length"
                key="loader"
                class="widget-body"
            >
                No shows
            </p>
            <template
                v-else
            >
                <div
                    v-for="show in recentShows"
                    :key="show.id"
                    class="widget-body"
                >
                    <router-link
                        v-slot="{ href, navigate, isActive }"
                        :to="`/shows/${show.hash}`"
                    >
                        <a
                            :class="['show', { 'is-frozen': show.isFrozen, 'router-link-active': isActive }]"
                            :href="href"
                            @click="navigate"
                        >
                            <base-show-image
                                :show="show"
                                size="medium-large"
                            />
                            <div class="content">
                                <p class="show-name">
                                    {{ show.title }}
                                </p>
                                <div class="bottom-content">
                                    <show-label
                                        :item="show"
                                        :allowed-labels="['plan', 'hosted', 'frozen', 'canceled']"
                                    />
                                    <p
                                        class="episodes-count"
                                    >
                                        {{ show.episodeCount }} <span> Episodes</span>
                                    </p>
                                </div>
                                <p
                                    v-if="show.isFrozen"
                                    class="frozen-deadline"
                                >
                                    Will be deleted on {{ getFrozenDeadline(show.frozenDeadline) }}
                                </p>
                            </div>
                        </a>
                    </router-link>
                </div>
            </template>
        </transition-group>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { sortBy } from 'lodash';
import ShowLabel from '@/components/Shows/ShowLabel';

export default {
    components: {
        ShowLabel,
    },

    computed: {
        ...mapState(['shows']),

        /**
         *
         * @returns  {Array}  Returns first 3 shows
         */
        recentShows() {
            return sortBy(this.shows, 'created_at').slice(0, 3) || false;
        },
    },

    methods: {
        /**
         * Gets the deadline for frozen show.
         *
         * @param {string} frozenDeadline Raw frozen deadline.
         * @returns {string} Frozen deadline.
         */
        getFrozenDeadline(frozenDeadline) {
            return moment(frozenDeadline).format('MMMM Do, YYYY');
        },
    },
};
</script>
